import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Slider from "react-slick";
import Modal from "react-responsive-modal";
import { useDispatch } from "react-redux";
import { show_for, get_promotion_prize } from "../../../../utils";
import { gaAddToCart, gaAddDetail } from "../../../Tracking/Tracking";
import backend from "../../../../api";
import { makeStyles } from "@material-ui/core/styles";
import { cart_actions } from "../../../../redux-store";
import WarningIcon from "@mui/icons-material/Warning";
import useDebounce from "../../../../components/pages/Dashboard/components/AdWorkShop/hooks/useDebounce";
import { toast } from "react-toastify";
import { formatPrice } from "../../../../utils/formatPrice";
import adManagerbackend from "../../../../api/api3";

const useStyles = makeStyles((theme) => ({
  outOfStockLabel: {
    display: "inline-block",
    backgroundColor: "rgba(255, 0, 0, 0.85)",
    color: "white",
    padding: "8px 12px",
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "uppercase",
    borderRadius: "5px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    marginBottom: "10px",
    textAlign: "center",
  },
  quantityExceedPrompt: {
    display: "flex",
    alignItems: "center",
    color: "#d32f2f",
    backgroundColor: "#fdecea",
    padding: "10px 15px",
    borderRadius: "5px",
    marginTop: "10px",
    fontWeight: "bold",
    fontSize: "14px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    "& svg": {
      marginRight: "8px",
    },
  },
}));

const DetailsWithPrice = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();
  const [memberUser, setMemberUser] = useState(null);
  const [sharedLinkId, setSharedLinkId] = useState(null);
  const [isAddedToCart, setIsAddedToCart] = useState(false);
  const [stock, setStock] = useState(
    props.item.stock_quantity > 0 ? "InStock" : "Out of Stock"
  );
  const [nav3, setNav3] = useState(null);
  const [modal, setModal] = useState(false);
  const [quantityExceed, setQuantityExceed] = useState(false);
  const [isInCart, setIsInCart] = useState(false);
  const slider1 = useRef(null);

  const history = useHistory();
  const searchParams = new URLSearchParams(history?.location?.search);
  const adCardId = searchParams.get("id");
  const debouncedQuantity = useDebounce(quantity, 500);
  const [quantityChanged, setQuantityChanged] = useState(false);

  const adId = searchParams.get("ad_id");
  const [bookAuthorId, setBookAuthorId] = useState("");

  const getAdDetails = async (id) => {
    try {
      const params = {
        ad_id: id,
      };
      const response = await adManagerbackend.get(`/adworkshop`, { params });
      const createdBy = response?.data?.data?.[0]?.created_by;
      const merchantId = props?.item?.merchant_user?._id;
      if (merchantId === createdBy) {
        const authorId = searchParams.get("book_author");
        setBookAuthorId(authorId || "");
      }
    } catch (error) {
      console.error("error: ", error);
    }
  };

  useEffect(() => {
    if(adId){
      getAdDetails(adId);
    }
  }, [adId]);

  const getAdcardDetails = async (id) => {
    try {
      const params = {
        _id: id,
        isActive: true,
      };
      const response = await backend.get("/sharedlink", { params });
      setSharedLinkId(response?.data?.data?.[0]?._id || null);
      setMemberUser(response?.data?.data?.[0]?.member_user || null);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  useEffect(() => {
    if(adCardId){
      getAdcardDetails(adCardId);
    }
  }, [adCardId]);

  useEffect(() => {
    setNav3(slider1.current);
    gaAddDetail(props.item, quantity);
  }, [props.item, quantity]);

  useEffect(() => {
    const cartItem = props?.cart?.find(
      (el) => el?.product?._id === props?.item?._id
    );
    if (cartItem) {
      setQuantity(cartItem.quantity);
      setIsInCart(true);
      setIsAddedToCart(true);
    }
  }, [props.cart, props.item._id]);

  useEffect(() => {
    if (isAddedToCart && !quantityExceed && quantityChanged) {
      updateCartItem(debouncedQuantity);
      setQuantityChanged(false);
    }
  }, [debouncedQuantity]);

  // Increment quantity
  const plusQty = () => {
    if (quantity < props.item.stock_quantity) {
      setQuantity((prevQuantity) => prevQuantity + 1);
      setQuantityExceed(false);
      setQuantityChanged(true);
    } else {
      setQuantityExceed(true);
    }
  };

  const minusQty = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
      setQuantityExceed(false);
      setQuantityChanged(true);
    }
  };

  const changeQty = (e) => {
    const newQuantity = parseInt(e.target.value);
    if (newQuantity <= props.item.stock_quantity) {
      setQuantity(newQuantity);
      setQuantityExceed(false);
      setQuantityChanged(true);
    } else {
      setQuantityExceed(true);
      setQuantity(props.item.stock_quantity);
    }
  };

  const {
    state,
    symbol,
    item,
    addToCartClicked,
    cart,
    BuynowClicked,
    addToWishlistClicked,
    create_adcard,
    wishlist,
  } = props;

  var colorsnav = {
    slidesToShow: 6,
    swipeToSlide: true,
    arrows: false,
    dots: false,
    focusOnSelect: true,
  };

  // const isInCart = cart?.some((cartItem) => cartItem.product._id === item._id);
  const isInWishlist = wishlist?.some(
    (wishlistItem) => wishlistItem?.product?._id === item?._id
  );
  const isOutOfStock = props.item.stock_quantity === 0;

  const updateCartItem = (newQuantity) => {
    const cartItem = props.cart.find((el) => el.product._id === props.item._id);
    if (cartItem) {
      dispatch(
        cart_actions.update_cart_item(cartItem, { quantity: newQuantity })
      );
    } else {
      toast.error("Item not found in cart");
    }
  };

  const addToCart = () => {
    // if (
    //   cart.length > 0 &&
    //   cart[0]?.product?.merchant_user !== item?.merchant_user?._id
    // ) {
    //   toast.error(
    //     "Please complete your purchase first before buying from a different Retailer"
    //   );
    //   return;
    // }

    if (item.stock_quantity > 0 && !quantityExceed) {
      addToCartClicked({
        product: item,
        quantity,
        member_user: memberUser,
        shared_link: sharedLinkId,
        book_author: bookAuthorId,
      });
      setIsAddedToCart(true);
      // setIsIconsDisabled(false);
      setIsInCart(true);
    }
  };

  return (
    <div className="col-lg-6 rtl-text">
      <div className="product-right">
        <h2>{item.product_name}</h2>
        <h3>{formatPrice(item.product_price)}</h3>
        {item.variants ? (
          <ul>
            <Slider
              {...colorsnav}
              asNavFor={props.navOne}
              ref={slider1}
              className="color-variant"
            >
              {item.variants.map((vari, i) => {
                return <li className={vari.color} key={i} title={vari.color} />;
              })}
            </Slider>
          </ul>
        ) : (
          ""
        )}
        {stock === "Out of Stock" && (
          <div className={classes.outOfStockLabel}>Out of Stock</div>
        )}
        {quantityExceed && (
          <div className={classes.quantityExceedPrompt}>
            <WarningIcon />
            Current quantity available is {props.item.stock_quantity}. You can't
            order more than that.
          </div>
        )}
        {show_for(
          ["member", "merchant"],
          <>
            <div className="product-description border-product">
              <h4 className="product-title">Promotion Prize</h4>
              <div className="qty-box">
                <h5>
                  {formatPrice(get_promotion_prize(item))}{" "}
                  <small className="text-muted">/ Item</small>
                </h5>
              </div>
            </div>
          </>
        )}
        {item &&
          show_for(
            ["customer"],
            <>
              <div className="product-description border-product">
                <h6 className="product-title">Quantity</h6>
                <div className="qty-box">
                  <div className="input-group">
                    <span className="input-group-prepend">
                      <button
                        type="button"
                        className="btn quantity-left-minus"
                        onClick={minusQty}
                        data-type="minus"
                        data-field=""
                        disabled={quantity <= 1}
                      >
                        <i className="fa fa-angle-left" />
                      </button>
                    </span>
                    <input
                      type="text"
                      name="quantity"
                      value={quantity}
                      onChange={changeQty}
                      className="form-control input-number"
                      disabled={quantityExceed}
                    />
                    <span className="input-group-prepend">
                      <button
                        type="button"
                        className="btn quantity-right-plus"
                        onClick={plusQty}
                        data-type="plus"
                        data-field=""
                        disabled={quantityExceed}
                      >
                        <i className="fa fa-angle-right" />
                      </button>
                    </span>
                  </div>
                </div>
              </div>

              <div className="product-buttons mt-3">
                <a
                  className={`btn btn-solid ${
                    isOutOfStock || quantityExceed || isAddedToCart
                      ? "disabled"
                      : ""
                  }`}
                  onClick={addToCart}
                  aria-disabled={
                    isOutOfStock || quantityExceed || isAddedToCart
                  }
                >
                  {isAddedToCart ? "Added to Cart" : "Add to Cart"}
                </a>
              </div>

              <div className="row product-buttons mt-3">
                <div className="col">
                  <Link
                    to={`${process.env.PUBLIC_URL}/product-catalogue/${item?.merchant_user?._id}`}
                    className="btn btn-solid"
                  >
                    View Merchant Catalogue
                  </Link>
                </div>
                <div className="col">
                  <Link
                    to={`${process.env.PUBLIC_URL}/merchants`}
                    className="btn btn-solid mt-3"
                  >
                    Visit Other Merchants
                  </Link>
                </div>
              </div>
            </>
          )}
        {show_for(
          ["merchant"],
          <>
            <div className="product-buttons mt-3">
              <Link
                className="btn btn-solid"
                to={`${process.env.PUBLIC_URL}/dashboard/merchant/create-product/${item._id}`}
              >
                Edit Product
              </Link>
            </div>
          </>
        )}
        <div className="border-product">
          {show_for(
            ["customer"],
            <div className="product-icon">
              <button
                className={`btn btn-solid ${isInWishlist ? "disabled" : ""}`}
                onClick={() =>
                  !isInWishlist &&
                  addToWishlistClicked({
                    product: item,
                    quantity: quantity,
                  })
                }
                disabled={isInWishlist} // Disable button if item is in wishlist
              >
                <i className="fa fa-heart" />
                <span className="title-font">
                  {isInWishlist ? "Already in Wishlist" : "Add to Wishlist"}
                </span>
              </button>
            </div>
          )}
        </div>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} center>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Sheer Straight Kurta
              </h5>
            </div>
            <div className="modal-body">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/size-chart.jpg`}
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </Modal>
      <Modal open={modal} onClose={() => setModal(false)} center>
        <div className="container px-5 pt-5 ">
          <div className="form-row mr-3">
            <div className="col-md-12 justify-content-center mb-3">
              <h3>
                Please complete your purchase first before buying from a
                different retailer
              </h3>
            </div>
            <br />
            <button
              className="btn btn-solid mt-3"
              onClick={() => setModal(false)}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DetailsWithPrice;
